module.exports = __webpack_public_path__ + "img/logo-lfb-couleur-400x350.6b956ef1.png";